<p class="text-lg font-semibold mb-xl">
  {{ 'user_form_screen_quick_create_department_title' | transloco }}
</p>

<form [formGroup]="formGroup" class="flex flex-col gap-lg">
  <div class="grid grid-cols-2 gap-lg">
    <div class="col-span-2">
      <div formGroupName="name">
        <lib-dual-lang-input
          [requiredGroup]="true"
          [inputFormControlName]="'name'"
          [id]="'quick_create_department_name'"
          type="text"
          name="name"
          [requiredEn]="false"
          [requiredAr]="false"
          [label]="'department_form_screen_department_name_label' | transloco"
          [placeholderEn]="
            'department_form_screen_department_name_placeholder_en'
              | transloco
          "
          [placeholderAr]="
            'department_form_screen_department_name_placeholder_ar'
              | transloco
          " />
      </div>
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="name" />
    </div>

    <div>
      <lib-input
        [inputFormControlName]="'identifier'"
        [id]="'quick_create_department_identifier'"
        type="text"
        name="identifier"
        [label]="'department_form_screen_department_id_label' | transloco"
        [placeholder]="'id_input_default_placeholder' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="identifier" />
    </div>

    <div>
      <lib-select
        [inputFormControlName]="'legal_entity_id'"
        id="quick_create_department_legal_entity_id"
        name="legal_entity_id"
        [label]="'department_form_screen_legal_entity_label' | transloco"
        [required]="true"
        [placeholder]="
          'department_form_screen_legal_entity_placeholder' | transloco
        "
        [options]="legalEntity()"
        [selectedKeyValue]="'value'"
        [selectedKeyName]="'label'" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="legal_entity_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_department_parent_id'"
        [inputFormControlName]="'parent_id'"
        [name]="'parent_id'"
        [label]="'department_form_screen_parent_label' | transloco"
        [placeholder]="'department_form_screen_parent_placeholder' | transloco"
        [apiUrl]="parentApi"
        [filters]="parentFilter"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="parent_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_department_direct_manager_id'"
        [inputFormControlName]="'direct_manager_id'"
        [name]="'direct_manager_id'"
        [label]="'department_form_screen_direct_manager_label' | transloco"
        [placeholder]="
          'department_form_screen_direct_manager_placeholder' | transloco
        "
        [apiUrl]="directManagerApi"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="direct_manager_id" />
    </div>

    <div>
      <lib-paginated-select
        [id]="'quick_create_department_type_option_id'"
        [inputFormControlName]="'department_type_option_id'"
        [name]="'department_type_option_id'"
        [label]="'department_form_screen_department_type_label' | transloco"
        [placeholder]="
          'department_form_screen_department_type_placeholder' | transloco
        "
        [apiUrl]="variableOptionsApi"
        [filters]="departmentTypeFilter"
        [noDataLabel]="'user_dropdown_input_no_data_label' | transloco" />
      <lib-validation-message
        [lang]="'current_lang' | transloco"
        control="department_type_option_id" />
    </div>
  </div>

  <div class="flex gap-md justify-end mt-lg">
    <button
      type="button"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm px-xl rounded-md text-base cursor-pointer"
      (click)="cancel()">
      {{ 'quick_create_cancel_button_label' | transloco }}
    </button>
    <button
      type="button"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()"
      class="bg-primary-500 py-sm px-xl rounded-md text-white text-base cursor-pointer"
      (click)="submit()">
      {{ 'quick_create_save_button_label' | transloco }}
    </button>
  </div>
</form>
